import 'jsbarcode';

/**
 * {RelivConferenceBadgePrintService}
 *
 * @param window
 * @param jQuery
 * @constructor
 */
export const RelivConferenceBadgePrintService = function (window, jQuery) {
    var self = this;

    /**
     * printElem
     * @param ticket
     */
    self.printElem = function (ticket) {

        var iFrameSrc
            = '/app_components/conference-ui/src/badge-print/print-badge-i-frame-inner.html?ticketJson='
            + encodeURIComponent(JSON.stringify(ticket));

        jQuery('html').prepend(
            `
<div id="badge-print-print-wrapper" style="z-index:999999;position:fixed;width:100%;height:100%;background-color: white">
<button id="badge-print-reprint">Reprint</button>
<iframe src="` + iFrameSrc + `" id="printf" name="printf" style="width:100%;height:100%;"></iframe>
</div>`
        );

        var printIframeEle = window.frames.printf;

        //Make the "reprint" button work which is useful for debugging print issues.
        document.getElementById('badge-print-reprint').addEventListener('click', function () {
            printIframeEle.print();
        });

        jQuery(printIframeEle.document).ready(
            function () {
                setTimeout(
                    function () {
                        printIframeEle.print();
                        setTimeout(
                            function () {
                                var wrapper = document.getElementById('badge-print-print-wrapper');
                                wrapper.parentNode.removeChild(wrapper);
                            },
                            1000 // Give humans a second to click "re-print" if they want to
                        );
                    },
                    1000 // Give plenty of time for the bar code and everything to be rendered
                );
            }
        );

        // }
    };

    /**
     * bind
     * @param element
     * @param ticket
     */
    self.bind = function (element, ticket) {
        element.bind(
            'click',
            function (evt) {
                evt.preventDefault();
                self.printElem(ticket);
            }
        );
    };
};
